var map = {
	"./上海/官网/1.jpg": 84893,
	"./北京/官网/1.jpg": 31226,
	"./南京/官网/1.jpg": 53647,
	"./广州/官网/1.jpg": 54131,
	"./成都/官网/1.jpg": 65790,
	"./杭州/官网/1.jpg": 81445,
	"./武汉/官网/1.jpg": 4485,
	"./深圳/官网/1.jpg": 63786,
	"./西安/官网/1.jpg": 98597
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 77243;